<template>
  <div>
    <img src="@/assets/heyitsme-icon.svg" class="back-btn-absolute" @click="$router.push('/')" alt="Home" role="button" />
    <h1 class="tips-title">These Tips Can Help</h1>
    <div class="tips-page">
      <div class="tips-list">
        <div class="tips-item">
          <h2>Use the questions below to help you brainstorm</h2>
          <p>
            Have you saved any quotes that resonated with you recently? Add them!<br><br>
            What's one way you can change your mindset that would make your life feel a little bit lighter today?<br><br>
            What is it that you need to hear right now? Add the first thing that comes to mind, judgment-free.<br><br>
            Pay attention to all of the ways you show up for yourself today. Did you make a healthy choice? Did you protect your time or energy by saying "no"? Adding these little moments as messages helps you see just how much you are there for yourself in ways that are hard to notice.<br><br>
            Have you read any self-growth books lately? Adding self-growth takeaways as messages helps you really absorb them, allowing them to fully integrate as a new part of your mindset.
          </p>
        </div>
        <div class="tips-item">
          <h2>Try adding one of these</h2>
          <p>You matter.</p><br>
          <p>You are enough just the way you are.</p><br>
          <p>You have the right to ask for what you need, even if it is an inconvenience to someone else.</p><br>
          <p>You are not responsible for other people's reactions to your boundaries.</p><br>
          <p>You are allowed to change your mind.</p><br>
          <p>You are allowed to set a boundary with your child, and your child is allowed to feel upset about it. Your child's reaction does not dictate your boundary. Validate their tough feelings and hold the boundary.</p><br>
          <p>You don't need permission to make a choice that is right for you.</p><br>
          <p>You don't need permission to feel the way you feel.</p><br>
          <p>Your feelings are valid. It makes sense that you feel this way.</p><br>
          <p>You deserve to take up space.</p><br>
          <p>Your story is important.</p>
        </div>
        <div class="tips-item">
          <h2>Review and edit regularly</h2>
          <p>Review your messages often so you can edit, update, or remove any that no longer serve you.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Tips for Success page styled like FAQPage
</script>

<style scoped>
.back-btn-absolute {
  position: absolute;
  top: 18px;
  left: 28px;
  z-index: 1000;
  width: 88px;
  height: 88px;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.2s;
}
.back-btn-absolute:hover {
  opacity: 0.75;
}
@media (max-width: 700px) {
  .back-btn-absolute {
    top: 8px;
    left: 14px;
    width: 68px;
    height: 68px;
  }
}
.tips-page {
  max-width: 700px;
  margin: 8px auto 32px auto;
  padding: 24px 32px;
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  text-align: left;
}
@media (max-width: 700px) {
  .tips-page {
    max-width: 98vw;
    padding: 12px 10vw;
  }
}
.tips-title {
  text-align: center;
  font-family: 'StayWonderful', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-size: 2.75rem;
  color: #312d30;
  margin-bottom: 32px;
  font-weight: 300;
}
.tips-list {
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.tips-item h2 {
  font-family: 'LemonCupcakeBold', 'Pacifico', 'Segoe Script', 'Brush Script MT', cursive;
  font-size: 2.5rem;
  color: #312d30;
  margin-bottom: 8px;
  font-weight: 300;
}
.tips-item p {
  font-family: 'Quicksand', 'Segoe UI', 'Georgia', serif;
  font-size: 1.08rem;
  color: #312d30;
  margin: 0;
}
</style>
